import { render } from "./px-questionary-criteria.vue?vue&type=template&id=d40d20c4&scoped=true&ts=true"
import script from "./px-questionary-criteria.vue?vue&type=script&lang=ts"
export * from "./px-questionary-criteria.vue?vue&type=script&lang=ts"

import "./px-questionary-criteria.vue?vue&type=style&index=0&id=d40d20c4&lang=scss&scoped=true"
import "./px-questionary-criteria.vue?vue&type=style&index=1&id=d40d20c4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40d20c4"]])

export default __exports__